import moment from 'moment';
import { isNumber } from 'lodash';

import * as base from '@/js/store/calculator/utilities/allPaymentsHelpers';

//  ****************************************************************************************************
//    For each calendar year, add the Hi3 Pension amount.
//  ****************************************************************************************************
function getHi3Pension(careerMonths, allPayments, firstMonthOutOfServiceDate, endOfLifeDate, key) {
  let obj = {};
  let hi3Pension = 0;
  let allPaymentsYear = firstMonthOutOfServiceDate.year();

  careerMonths.forEach((careerMonth) => {
    const calendarYear = Number(careerMonth.calendarYear);
    const calendarMonth = Number(careerMonth.calendarMonth);
    const calendarDate = moment([calendarYear, calendarMonth - 1, 1]);

    if (calendarDate.isSameOrAfter(firstMonthOutOfServiceDate)) {
      if (calendarMonth === 1) {
        obj = allPayments.data.find((o) => o.calendarYear === allPaymentsYear);
        obj.pensionPaymentAmount = hi3Pension === 0 ? '' : hi3Pension;
        hi3Pension = 0;
        allPaymentsYear = calendarYear;
      }

      hi3Pension += careerMonth[key];

      //  Ensure retSep year are included.
      //  endOfLifeDate is last day of the month. Only check year and month.
      if (calendarYear === endOfLifeDate.year() && calendarMonth === endOfLifeDate.month() + 1) {
        obj = allPayments.data.find((o) => o.calendarYear === calendarYear);
        obj.pensionPaymentAmount = hi3Pension === 0 ? '' : hi3Pension;
      }
    }
  });

  return allPayments.data;
}

//  ****************************************************************************************************
//    For each calendar year, sum the Hi3 Pension amount and TSP Payout amount.
//  ****************************************************************************************************
function getHi3Total(allPayments) {
  allPayments.data.forEach((item) => {
    const hi3Pension = isNumber(item.pensionPaymentAmount) ? item.pensionPaymentAmount : 0;
    const tspPayout = isNumber(item.tspServiceMemberPaymentAmount) ? item.tspServiceMemberPaymentAmount : 0;

    item.pensionTotal = hi3Pension + tspPayout === 0 ? '' : hi3Pension + tspPayout;
  });

  return allPayments.data;
}

//  ****************************************************************************************************
//    Generate data to be displayed in the All-Payments results tab.
//  ****************************************************************************************************
function populateHi3Data(allPayments, serviceMember, keys) {
  const { allNumbersByMonth } = serviceMember.results;

  const endOfLifeDate = serviceMember.endOfLifeDate();
  const firstMonthOutOfServiceDate = serviceMember.firstMonthOutOfServiceDate();

  allPayments.data = serviceMember.pensionRetirementType() !== serviceMember.RETIREMENT_ELIGIBILITIES.TSP_ONLY
    ? getHi3Pension(allNumbersByMonth, allPayments, firstMonthOutOfServiceDate, endOfLifeDate, keys.hi3PensionAmountKey)
    : allPayments.data;
  allPayments.data = getHi3Total(allPayments);

  return allPayments;
}

export function getResultsAllPaymentsInFutureDollars(serviceMember) {
  const allPayments = base.getResultsAllPaymentsInFutureDollars(serviceMember);

  populateHi3Data(allPayments, serviceMember, {
    hi3PensionAmountKey: 'pensionAmountFutureDollars',
  });

  return allPayments;
}

export function getResultsAllPaymentsInTodaysDollars(serviceMember) {
  const allPayments = base.getResultsAllPaymentsInTodaysDollars(serviceMember);

  populateHi3Data(allPayments, serviceMember, {
    hi3PensionAmountKey: 'pensionAmountTodaysDollars',
  });

  return allPayments;
}
